<div class="card {{CardClass}}" [style.width.px]="WidthPx">    
    <ng-content select="[card-header]"></ng-content>
    <ng-content select="[card-body]"></ng-content>
    <ng-content select="[card-footer]"></ng-content>
</div>



// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/cards/card/card.html